module.exports = __webpack_public_path__ + "img/document.fdac4b86.svg";